import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Loading, Avatar } from "../components/common";
import { Trophy, Flame, Target, Rss } from "lucide-react";

const ICONS = {
  match: { icon: Trophy, color: "#FFCC00", bg: "#2b2410" },
  one_eighty: { icon: Flame, color: "#FF3B30", bg: "#241010" },
  checkout: { icon: Target, color: "#34C759", bg: "#12331d" },
};

function timeAgo(iso) {
  if (!iso) return "";
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  if (d < 60) return "just now";
  if (d < 3600) return `${Math.floor(d / 60)}m ago`;
  if (d < 86400) return `${Math.floor(d / 3600)}h ago`;
  return `${Math.floor(d / 86400)}d ago`;
}

export default function Feed() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => setItems((await api.get("/feed")).data))();
  }, []);

  if (items === null) return <Loading label="Loading feed" />;

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FF3B30] mb-2">Club</div>
        <h1 className="font-display text-5xl md:text-6xl font-black uppercase tracking-tighter text-white leading-none">
          Activity Feed
        </h1>
      </div>

      {items.length === 0 ? (
        <div className="panel rounded-sm p-8 text-center text-slate-500">
          <Rss className="w-8 h-8 mx-auto mb-3 text-slate-700" />
          Nothing here yet. Play some matches to fill the feed with wins, 180s and big checkouts.
        </div>
      ) : (
        <div className="space-y-1">
          {items.map((it) => {
            const cfg = ICONS[it.type] || ICONS.match;
            const Icon = cfg.icon;
            return (
              <button
                key={it.id}
                data-testid={`feed-item-${it.type}`}
                onClick={() => it.match_id && navigate(`/match/${it.match_id}`)}
                className="panel rounded-sm p-4 w-full flex items-center gap-3 text-left hover:border-[#007AFF] transition-colors"
              >
                <div
                  className="w-11 h-11 flex items-center justify-center rounded-sm shrink-0"
                  style={{ backgroundColor: cfg.bg }}
                >
                  <Icon className="w-5 h-5" style={{ color: cfg.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-display text-lg font-bold text-white leading-tight truncate">
                    {it.title}
                  </div>
                  <div className="text-sm text-slate-400 truncate">{it.subtitle}</div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <Avatar name={it.player} size={30} />
                  <span className="text-xs font-bold uppercase text-slate-500 w-14 text-right">
                    {timeAgo(it.date)}
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
